import { render, staticRenderFns } from "./DetailsParticipant.vue?vue&type=template&id=7a9990b8&scoped=true"
import script from "./DetailsParticipant.vue?vue&type=script&lang=ts"
export * from "./DetailsParticipant.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a9990b8",
  null
  
)

export default component.exports